import styled from "styled-components"

const StyledChangeDirection = styled.section`
  padding-bottom: 547px;
  .change-direction {
    &__container {
      padding-bottom: 115px;
      /* background-color: rgba(0, 0, 0, 0.51); */
    }
    &__header {
      position: relative;
      z-index: 1;
      padding: 130px 0 48px;
      text-align: center;
      .text-label {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .title {
        /* color: #fff; */
      }
    }
    &__wrapper {
      display: flex;
      .change-direction-box {
        text-align: center;
        position: relative;
        .text-holder {
          position: relative;
          border: 4px solid #000;
          border-bottom: 0;
          padding: 30px 20px 38px;
          height: 100%;
          &::before,
          &::after {
            content: "";
            display: block;
            position: absolute;
            height: 4px;
            background-color: #000;
            bottom: -4px;
          }
          &::before {
            left: -4px;
          }
          &::after {
            right: -4px;
          }
          p {
            /* color: #fff; */
          }
          .title {
            font-size: 34px;
            line-height: 43px;
            text-transform: uppercase;
            margin-bottom: 9px;
          }
          .desc {
            font-size: 18px;
            line-height: 24px;
          }
        }
        .image-holder {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        &.eco {
          flex-basis: 38.5%;
          .text-holder {
            &::before,
            &::after {
              width: calc(50% - 60px);
            }
            .desc {
              /* max-width: 330px; */
              margin: 0 auto;
            }
          }
          .image-holder {
            top: calc(100% - 28px);
          }
        }
        &.second_life {
          margin-left: 27px;
          flex: 1;
          .text-holder {
            &::before,
            &::after {
              width: calc(50% - 78px);
            }
          }

          .image-holder {
            top: calc(100% - 44px);

            img {
              min-height: 484px;
              width: min-content;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1100px) {
    padding-bottom: 0;
    .change-direction {
      &__container {
        padding-bottom: 50px;
      }
      &__wrapper {
        flex-flow: wrap;
        .change-direction-box {
          margin-bottom: 50px;
          .text-holder {
            height: initial;
          }
          .image-holder {
            position: static;
            transform: none;
          }
          &.eco {
            flex-basis: 100%;
            .image-holder {
              margin-top: -25px;
              img {
                max-width: 100%;
              }
            }
          }
          &.second_life {
            margin-left: 0;
            flex-basis: 100%;
            .text-holder {
              padding-bottom: 60px;
            }
            .image-holder {
              margin-top: -60px;
              img {
                max-width: 640px;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 670px) {
    .change-direction {
      &__wrapper {
        .change-direction-box {
          &.eco {
            .image-holder {
              margin-top: -20px;
              img {
                max-width: 100px;
              }
            }
          }
          &.second_life {
            .text-holder {
              padding-bottom: 50px;
              &:before,
              &:after {
                width: calc(50% - 50px);
              }
            }
            .image-holder {
              margin-top: -115px;
              img {
                max-width: 440px;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .change-direction {
      &__header {
        padding: 64px 0 38px;
        .title {
          font-size: 34px;
          line-height: 43px;
        }
      }
      &__wrapper {
        .change-direction-box {
          .text-holder {
            padding: 20px 10px 28px;

            .title {
              margin-bottom: 6px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 470px) {
    .change-direction {
      &__wrapper {
        .change-direction-box {
          &.eco {
            .image-holder {
              margin-top: -12px;
            }
          }

          &.second_life {
            .text-holder {
              &:before,
              &:after {
                width: calc(50% - 35px);
              }
            }
            .image-holder {
              margin-top: -150px;
              img {
                max-width: 320px;
              }
            }
          }
        }
      }
    }
  }
`
export default StyledChangeDirection
